var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"row fit window-height justify-center items-center"},[_c('q-spinner',{attrs:{"color":"primary","size":"6rem","trickness":4}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }